// jQuery
window.$ = window.jQuery = require("jquery");

// Bootstrap collapse
require("bootstrap-sass/assets/javascripts/bootstrap/collapse.js");

// Constnts
require("./constants");

// Global Variables
require("./globalVariables");

// Lodash
window._ = require("lodash");

// Vue
window.Vue = require("vue");

// Vuex
window.Vuex = require("vuex");

// Axios
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Token
window.token = document.head.querySelector('meta[name="csrf-token"]').content;

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
} else {
  console.error(
    "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
  );
}

// Vendor plugins
window.iziToast = require("izitoast");
require("air-datepicker");
require("fastselect");
import Dropzone from "dropzone";

// Owner plugins
require("./plugins/modal-window");
require("./plugins/mobile-menu");
